// src/components/dashboard/DashboardRules.tsx
import React from 'react';

export const DashboardRules: React.FC = () => (
  <div className="rounded-xl border border-brand-border p-6">
    <h1 className="text-lg font-semibold text-brand-black">Rules Studio</h1>
    <p className="text-sm text-brand-gray mt-1">Rules of Engagement configuration — coming online.</p>
  </div>
);